import { useCallback, useMemo } from 'react';
export const YotpoStars = (product) => {
    const yotpoAverageScore = product.yotpo_average_score ?? null;
    const decimalValue = parseInt(yotpoAverageScore);
    const fractionalValue = Math.round((yotpoAverageScore - parseInt(String(yotpoAverageScore))) * 10);

    const starsColor$ = useCallback(
        (index) => {
            return decimalValue > index || (fractionalValue > 7 && decimalValue === index)
                ? 'yotpo-icon-star'
                : fractionalValue > 3 && decimalValue === index
                ? 'yotpo-icon-half-star'
                : 'yotpo-icon-empty-star';
        },
        [decimalValue, fractionalValue],
    );

    const stars$ = useMemo(() => {
        const items = [];
        for (let index = 0; index < 5; index++) {
            items.push(<span className={`yotpo-icon ${starsColor$(index)}  rating-star pull-left`} />);
        }
        return items;
    }, [yotpoAverageScore, decimalValue, fractionalValue]);

    return (
        <div className="yotpo bottomLine yotpo-small" data-yotpo-element-id="1">
            <div className="yotpo-display-wrapper" style={{ visibility: 'hidden' }}>
                <div className="standalone-bottomline" data-source="default">
                    {yotpoAverageScore && (
                        <div className="yotpo-bottomline pull-left star-clickable">
                            <span className="yotpo-stars">{stars$}</span>
                            <div className="yotpo-clr"></div>
                        </div>
                    )}
                    <div className="yotpo-clr"></div>
                </div>
                <div className="yotpo-clr"></div>
            </div>
        </div>
    );
};
